import { render, staticRenderFns } from "./ContactError.vue?vue&type=template&id=849c272e&scoped=true&"
import script from "./ContactError.vue?vue&type=script&lang=js&"
export * from "./ContactError.vue?vue&type=script&lang=js&"
import style0 from "./ContactError.vue?vue&type=style&index=0&id=849c272e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "849c272e",
  null
  
)

export default component.exports